import React from 'react';
import { Button, Space } from 'antd';

interface FormNavigationProps {
  currentStep: number;
  totalSteps: number;
  onPrev: () => void;
  onNext: () => void;
  onSave: () => void;
  onSubmit: () => void;
  submitting: boolean;
}

export default function FormNavigation({ currentStep, totalSteps, onPrev, onNext, onSave, onSubmit, submitting }: FormNavigationProps) {
  const isLast = currentStep === totalSteps - 1;

  return (
    <div className="flex justify-between mt-6 pt-4 border-t">
      <Space>
        {currentStep > 0 && (
          <Button onClick={onPrev}>Anterior</Button>
        )}
      </Space>
      <Space>
        <Button onClick={onSave} loading={submitting}>Salvar Rascunho</Button>
        {isLast ? (
          <Button type="primary" onClick={onSubmit} loading={submitting}>
            Enviar Formulário
          </Button>
        ) : (
          <Button type="primary" onClick={onNext}>Próximo</Button>
        )}
      </Space>
    </div>
  );
}
